export default {
      id: "battery-lvl-75-usage",
      viewBox: "0 0 22 14",
      url: __webpack_public_path__ + "img/icons.svg#battery-lvl-75",
      toString: function () {
        return this.url;
      }
    }